import { ModuleConst } from './keys.constant';

export interface GlobalSearchItem {
  title: string;
  keywords: string[];
  route: string;
  module: string;
  description?: string;
  sub_module?: string;
}

export const GLOBAL_SEARCH_ITEMS: GlobalSearchItem[] = [
  // Dashboard
  {
    title: 'Dashboard',
    keywords: [
      'dashboard',
      'analytics',
      'overview',
      'statistics',
      'charts',
      'Home',
    ],
    route: '/dashboard',
    module: ModuleConst.Dashboard,
    description: 'Overview of system performance and statistics',
  },

  // Admin Panel
  {
    title: 'Admin Role',
    keywords: [
      'admin role',
      'permissions',
      'access control',
      'roles',
      'privileges',
      'sub admin',
      'add admin',
      'edit admin',
      'delete admin',
      'block admin',
      'unblock admin',
      'admin block',
      'admin unblock',
      'admin delete',
      'admin edit',
      'admin add',
    ],
    route: '/admin/admin-role?tab=0',
    module: ModuleConst.AdminPanel,
    sub_module: ModuleConst.AdminRole,
    description: 'Manage admin roles and permissions',
  },

  {
    title: 'Users',
    keywords: [
      'users',
      'manage users',
      'clients',
      'delete user',
      'block user',
      'unblock user',
      'user block',
      'user unblock',
      'user delete',
    ],
    route: '/admin/users',
    module: ModuleConst.AdminPanel,
    sub_module: ModuleConst.Users,
    description: 'Manage sub-admin users',
  },
  {
    title: 'Manage Service Providers',
    keywords: [
      'service provider',
      'sp',
      'manage sp',
      'vendors',
      'providers',
      'add service provider',
      'edit service provider',
      'delete service provider',
      'block service provider',
      'unblock service provider',
      'service provider block',
      'service provider unblock',
      'service provider delete',
      'service provider edit',
      'service provider add',
      'export service provide data',
      'Driver Doc.',
      'Account Type',
      'Registration document status',
      'Payment document status',
      'Sp - Document',
      'Payment Options',
      'Payment Options',
      'Vehicle Doc.',
    ],
    route: '/admin/service-provider',
    module: ModuleConst.AdminPanel,
    sub_module: ModuleConst.SP,
    description: 'Manage service providers',
  },
  {
    title: 'Drivers',
    keywords: [
      'Drivers',
      'manage drivers',
      'Driver Type',
      'Inactive/Active driver',
      'Active Hours',
      'Block/Unblock',
      'Documents',
      'Driver Documents',
      'Driver Chats',
    ],
    route: '/admin/drivers',
    module: ModuleConst.AdminPanel,
    sub_module: ModuleConst.Drivers,
    description: 'Manage drivers',
  },
  {
    title: 'Languages',
    keywords: ['languages', 'localization', 'translation', 'locale'],
    route: '/admin/languages',
    module: ModuleConst.AdminPanel,
    sub_module: ModuleConst.Languages,
    description: 'Manage system languages',
  },
  {
    title: 'Policies',
    keywords: [
      'cms',
      'About Us Driver',
      'About Us Service Provider',
      'terms',
      'conditions',
      'legal',
      'faqs',
      'privacy policy',
    ],
    route: '/admin/policies',
    module: ModuleConst.AdminPanel,
    sub_module: ModuleConst.policies,
    description: 'Manage legal policies',
  },

  // Settings
  {
    title: 'Modules',
    keywords: [
      'modules',
      'home page settings',
      'module name',
      'sorting number',
      'edit module',
      'module edit',
    ],
    route: '/settings/main/modules',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.Modules,
    description: 'Configure app modules',
  },
  {
    title: 'Category',
    keywords: [
      'category',
      'categories',
      'module category',
      'sorting number',
      'edit category',
      'category edit',
    ],
    route: '/settings/main/category',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.Category,
    description: 'Manage categories',
  },
  {
    title: 'Sub-Category',
    keywords: [
      'sub-category',
      'types',
      'sub types',
      'weight_from',
      'weight_to',
      'commission',
      'schedule type',
      'minimum distance',
      'add sub category',
      'sub category add',
      'edit sub category',
      'sub category edit',
      'Import Sub Category',
      'Sample Sub Category',
    ],
    route: '/settings/main/sub-category',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.Types,
    description: 'Manage sub-categories and types',
  },
  {
    title: 'Commodity',
    keywords: [
      'commodity',
      'goods',
      'priority',
      'tiles',
      'oil',
      'bricks',
      'add commodity',
      'commodity add',
      'edit commodity',
      'commodity edit',
      'import commodity',
      'sample commodity',
    ],
    route: '/settings/main/commodity',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.Commodity,
    description: 'Manage commodities',
  },

  // Country Settings
  {
    title: 'Country',
    keywords: [
      'country',
      'flag',
      'country name',
      'country code',
      'currency code',
      'currency',
      'country prefix',
      'support phone number',
      'driver enquiry show time',
      'walkthrough',
      'tax',
      'tax name',
      'rate',
    ],
    route: '/settings/countrySettings/country',
    module: ModuleConst.Country,
    sub_module: ModuleConst.Country,
    description: 'Manage countries and currencies',
  },
  {
    title: 'Licence Region',
    keywords: [
      'licence region',
      'region',
      'operating region',
      'Payment Docs',
      'I icons info',
      'add Licence Region',
      'edit Licence Region',
      'delete Licence Region',
    ],
    route: '/settings/countrySettings/licence-region',
    module: ModuleConst.Country,
    sub_module: ModuleConst.Licence_Region,
    description: 'Manage license regions',
  },
  {
    title: 'Zones',
    keywords: [
      'zones',
      'geofencing',
      'areas',
      'map zones',
      'add zone',
      'edit zone',
      'delete zone',
    ],
    route: '/settings/countrySettings/zones',
    module: ModuleConst.Country,
    sub_module: ModuleConst.zone,
    description: 'Manage operational zones',
  },
  {
    title: 'Surge Settings',
    keywords: [
      'surge',
      'surge type',
      'day of week',
      'pricing',
      'multiplier',
      'peak hours',
      'add surge',
      'edit surge',
      'delete surge',
    ],
    route: '/settings/countrySettings/surge',
    module: ModuleConst.Country,
    sub_module: ModuleConst.surge,
    description: 'Manage surge pricing',
  },

  // Transport Settings
  {
    title: 'Immediate Query Settings',
    keywords: [
      'immediate query',
      'transport settings',
      'immediate booking',
      'Attempt Number',
      'Hold Time',
      'Auto Payment Failed Time',
      'Hold Range',
      'add immediate query',
      'edit immediate query',
      'delete immediate query',
    ],
    route: '/settings/transport',
    module: ModuleConst.immedidateQuery,
    sub_module: ModuleConst.immedidateQuery,
    description: 'Configure immediate query settings',
  },
  {
    title: 'Ride Share Settings',
    keywords: [
      'ride share',
      'user radius',
      'driver radius',
      'share ride',
      'carpowol',
      'Attempt Number',
      'add ride share',
      'edit ride share',
      'delete ride share',
      'Hold Time',
      'Hold Range',
    ],
    route: '/settings/transport',
    module: ModuleConst.immedidateQuery,
    sub_module: ModuleConst.rideShare,
    description: 'Configure ride sharing settings',
  },

  // Delivery Settings
  {
    title: 'Delivery Charges',
    keywords: [
      'delivery charges',
      'start distance',
      'end distance',
      'defult price',
      'extra price per km',
      'delivery fees',
    ],
    route: '/settings/delivery-settings/delivery-charges',
    module: ModuleConst.DeliveryQuerySettings,
    sub_module: ModuleConst.Delivery_Charges,
    description: 'Configure delivery charges',
  },
  {
    title: 'Delivery Query Settings',
    keywords: [
      'delivery query',
      'delivery settings',
      'Max Range',
      'Hold Range',
      'Hold Time Driver',
      'Auto Cancel Time',
      '',
    ],
    route: '/settings/delivery-settings/delivery-query-settings',
    module: ModuleConst.DeliveryQuerySettings,
    sub_module: ModuleConst.DeliveryQuerySettings,
    description: 'Configure delivery query settings',
  },

  // Cancellation Settings
  {
    title: 'Cancellation Charges',
    keywords: [
      'cancellation charges',
      'cancel fees',
      'Per KM Rate',
      'Per Min Rate',
      'Percentage',
      'add cancellation charges',
      'edit cancellation charges',
      'delete cancellation charges',
    ],
    route: '/settings/cancellation',
    module: ModuleConst.cancellation,
    sub_module: ModuleConst.cancellation,
    description: 'Manage cancellation charges',
  },
  {
    title: 'Cancellation Reasons',
    keywords: [
      'cancellation reasons',
      'user type',
      'reason',
      'cancel reason',
      'add cancellation reason',
      'edit cancellation reason',
      'delete cancellation reason',
    ],
    route: '/settings/cancellation',
    module: ModuleConst.cancellation,
    sub_module: ModuleConst.charges, // Using ModuleConst.charges based on sidebar map, sidebar has query params though
    description: 'Manage cancellation reasons',
  },

  {
    title: 'Notifications',
    keywords: ['notifications', 'broadcast', 'push notifications', 'alerts'],
    route: '/settings/notifications',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.notifications,
    description: 'Manage broadcast notifications',
  },
  {
    title: 'Preferences',
    keywords: ['preferences', 'sorting', 'options', 'filters'],
    route: '/settings/preferences',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.Preferences,
    description: 'Manage system preferences',
  },
  {
    title: 'Upload Images',
    keywords: ['upload images', 'assets', 'media', 'files'],
    route: '/settings/upload-images',
    module: ModuleConst.Settings,
    sub_module: ModuleConst.Upload_Images,
    description: 'Upload system images',
  },

  // Vehicle Setup
  {
    title: 'Brands',
    keywords: [
      'brands',
      'vehicle brands',
      'make',
      'manufacturer',
      'brand name',
      'sample',
      'Import',
      'Export',
      'add brand',
      'edit brand',
      'delete brand',
    ],
    route: '/vehicle-setup/brands',
    module: ModuleConst.vehicleSetup,
    sub_module: ModuleConst.Brands,
    description: 'Manage vehicle brands',
  },
  {
    title: 'Vehicles',
    keywords: [
      'vehicles',
      'vehicle type',
      'bid count',
      'min bid amount',
      'max bid percentage',
      'commission',
      'seats',
      'eco mode',
      'ride sharing',
      'add vehicle',
      'edit vehicle',
      'delete vehicle',
    ],
    route: '/vehicle-setup/vehicles',
    module: ModuleConst.vehicleSetup,
    sub_module: ModuleConst.Vehicles,
    description: 'Manage vehicle types and configurations',
  },
  {
    title: 'Vehicle Approval',
    keywords: [
      'vehicle approval',
      'approve',
      'verify vehicle',
      'pending approval',
      'Merchant Code',
    ],
    route: '/vehicle-setup/vehicle-approval',
    module: ModuleConst.vehicleSetup,
    sub_module: ModuleConst.VehicleApproval,
    description: 'Approve new vehicles',
  },
  {
    title: 'Vehicles Inventory',
    keywords: [
      'vehicle inventory',
      'fleet',
      'all vehicles',
      'Today Booked Vehicles',
      'Total Vehicles',
    ],
    route: '/vehicle-setup/vehicle-inventory',
    module: ModuleConst.vehicleSetup,
    sub_module: ModuleConst.vehicleInventory,
    description: 'View vehicle inventory',
  },

  // Trip Status
  {
    title: 'Enquiries',
    keywords: [
      'enquiries',
      'requests',
      'status',
      'live enquiries',
      'Bids',
      'Immediate',
      'Bid status',
      'Immediate Status',
      'Schedule Start',
      'Auction Start',
      'Auction End',
    ],
    route: '/status/enquiries',
    module: ModuleConst.Status,
    sub_module: ModuleConst.Enquiries,
    description: 'View live enquiries',
  },
  {
    title: 'All Trips',
    keywords: [
      'trips',
      'Driver Assign',
      'Manual Driver Assign',
      'Logibids Commission',
      'Service Charges',
      'Logibids Tax',
      'SP tax',
      'Update Status',
      'Trip Status',
      'bookings',
      'all trips',
      'journey',
    ],
    route: '/status/trips',
    module: ModuleConst.Status,
    sub_module: ModuleConst.Trips,
    description: 'View all trips',
  },
  {
    title: 'Service Provider Trips',
    keywords: ['service provider trips', 'sp trips', 'trip Details'],
    route: '/status/service-trip',
    module: ModuleConst.Status,
    sub_module: ModuleConst.Service_Provider_Trip,
    description: 'View service provider trips',
  },
  {
    title: 'History',
    keywords: [
      'history',
      'past trips',
      'completed trips',
      'archived',
      'Bids',
      'Immediate',
    ],
    route: '/status/history/enquiries',
    module: ModuleConst.Status,
    sub_module: ModuleConst.statusHistory,
    description: 'View trip history',
  },
  {
    title: 'History',
    keywords: [
      'history',
      'past Enquiries',
      'completed Enquiries',
      'archived',
      'Bids',
      'Immediate',
    ],
    route: '/status/history/trips',
    module: ModuleConst.Status,
    sub_module: ModuleConst.statusHistory,
    description: 'View trip history',
  },
  {
    title: 'Heat Map',
    keywords: ['heat map', 'demand map', 'density', 'live map'],
    route: '/status/heat-map',
    module: ModuleConst.Status,
    sub_module: ModuleConst.heat_map,
    description: 'View demand heat map',
  },

  // Accounts
  {
    title: 'Account Dashboard',
    keywords: [
      'account dashboard',
      'finance',
      'revenue',
      'earnings',
      'Total Revenue',
      'Total Paid to Service Provider',
      'Total Commission',
      'Wallet Amount',
      'Total Enqueries',
      'Total Paid Enquiries',
      'Total Failed Enquiries',
    ],
    route: '/accounts/dashboard',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.accountsDashboard,
    description: 'Accounts overview',
  },
  {
    title: 'Transaction History',
    keywords: [
      'transaction history',
      'ledger',
      'credits',
      'debits',
      'balance',
      'Indiviual History',
      'Service Provider History',
      'User History',
    ],
    route: '/accounts/ledger',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.ledger,
    description: 'View transaction history',
  },
  {
    title: 'Enquiries Status',
    keywords: [
      'enquiries status',
      'payment management',
      'payment status',
      'wallet',
      'Transaction ID',
      'Cash Received',
      'Refund',
      'Payment Method',
      'Service providers status',
      'Bid Amount',
      'SP Payment Mode',
    ],
    route: '/accounts/payment-management',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.paymentManagement,
    description: 'Manage enquiry payments',
  },
  {
    title: 'Service Provider Payment',
    keywords: [
      'service provider payment',
      'sp payment',
      'payouts',
      'payables',
      'Pending Payment',
      'Payment History',
    ],
    route: '/accounts/sp-payment-management',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.spPaymentManagement,
    description: 'Manage service provider payments',
  },
  {
    title: "User's Wallet Balance",
    keywords: ['wallet balance', 'user wallet', 'credits', 'topup'],
    route: '/accounts/wallet-history',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.walletHistory,
    description: 'View user wallet history',
  },
  {
    title: "User's Minimum Wallet",
    keywords: ['minimum wallet', 'min balance', 'wallet threshold'],
    route: '/accounts/minimum-wallet',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.minWallet,
    description: 'Set minimum wallet balance',
  },
  {
    title: 'Accounts Vehicles',
    keywords: ['accounts vehicles', 'vehicle accounts', 'Commission', 'seats'],
    route: '/accounts/vehicles',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.accountVehicle,
    description: 'Vehicle accounts',
  },
  {
    title: 'Vehicles Commission',
    keywords: [
      'vehicle commission',
      'commission rates',
      'charges',
      'add commission',
      'Vehicle Commission',
    ],
    route: '/accounts/vehicle-commission',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.VehicleCommission,
    description: 'Manage vehicle commissions',
  },
  {
    title: 'Delivery Accounts',
    keywords: ['delivery accounts', 'delivery finance'],
    route: '/accounts/delivery',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.delivery,
    description: 'Delivery accounts',
  },
  {
    title: 'Delivery Commission',
    keywords: [
      'delivery commission',
      'delivery rates',
      'country wise commission',
      'edit commission',
      'add commission',
      'Delivery Commission',
    ],
    route: '/accounts/delivery-commission',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.deliveryCommission,
    description: 'Manage delivery commissions',
  },
  {
    title: 'Fare',
    keywords: [
      'fare',
      'base fare',
      'per km rate',
      'per min rate',
      'waiting time',
      'pickup waiting range',
      'charge rate',
      'auto driver switch',
      'pricing model',
    ],
    route: '/accounts/fare',
    module: ModuleConst.accounts,
    sub_module: ModuleConst.fare,
    description: 'Manage fare settings and formulas',
  },

  // Loyalty
  {
    title: 'Loyalty Dashboard',
    keywords: [
      'loyalty dashboard',
      'rewards',
      'points',
      'loyalty',
      'Expired Points',
      'Basic Users',
      'Gold Users',
      'Platinum Users',
      'Tier Chart',
      'Activation Chart',
    ],
    route: '/loyalty/dashboard',
    module: ModuleConst.loyalty,
    sub_module: ModuleConst.loyaltyDashboard,
    description: 'Loyalty program overview',
  },
  {
    title: 'Loyalty Settings',
    keywords: [
      'loyalty settings',
      'evaluation days',
      'point value',
      'redemption',
      'tiers',
      'rules',
      'add tier',
      'edit tier',
      'add rule',
      'edit rule',
    ],
    route: '/loyalty/settings',
    module: ModuleConst.loyalty,
    sub_module: ModuleConst.loyaltySettings,
    description: 'Configure loyalty program settings',
  },

  // CRM Management
  {
    title: 'CRM Dashboard',
    keywords: ['crm', 'crm dashboard', 'customer support dashboard'],
    route: '/crm/dashboard',
    module: ModuleConst.CRM_Management,
    sub_module: ModuleConst.CRM_Dashboard,
    description: 'CRM overview dashboard',
  },
  {
    title: 'Chat Listing',
    keywords: [
      'chat listing',
      'crm chat',
      'support chat',
      'tickets',
      'conversations',
      'messages',
      'agent portal',
      'my chats',
    ],
    route: '/crm/chat-listing',
    module: ModuleConst.CRM_Management,
    sub_module: ModuleConst.CRM_ChatListing,
    description: 'View and manage customer chats',
  },
  {
    title: 'Agent Management',
    keywords: ['agent management', 'crm agents', 'support agents'],
    route: '/crm/agents',
    module: ModuleConst.CRM_Management,
    sub_module: ModuleConst.CRM_Agents,
    description: 'Manage CRM agents',
  },
  {
    title: 'Tags Management',
    keywords: ['tags', 'crm tags', 'chat tags', 'labels'],
    route: '/crm/tags',
    module: ModuleConst.CRM_Management,
    sub_module: ModuleConst.CRM_Tags,
    description: 'Manage CRM chat tags',
  },
  {
    title: 'Timeline / Logs',
    keywords: ['timeline', 'crm logs', 'chat logs', 'activity logs'],
    route: '/crm/timeline',
    module: ModuleConst.CRM_Management,
    sub_module: ModuleConst.CRM_Timeline,
    description: 'View CRM timeline and logs',
  },
  {
    title: 'Decision Tree Builder',
    keywords: ['decision tree', 'crm bot', 'automation', 'flow builder'],
    route: '/crm/decision-tree',
    module: ModuleConst.CRM_Management,
    sub_module: ModuleConst.CRM_DecisionTree,
    description: 'Configure CRM decision tree',
  },

  // Profile
  {
    title: 'Profile',
    keywords: ['profile', 'edit profile', 'my account', 'admin profile'],
    route: '/profile',
    module: ModuleConst.Profile,
    description: 'Manage admin profile',
  },
];
